<template>
  <div>
    Dashboard
  </div>
</template>

<script>
import { TitleMixin } from "@/mixins";

/**
 * Dashboard view
 */
export default {
  name: "Dashboard",
  /**
   *  ---------------- Page title ------------------
   */
  title: "Dashboard",
  /**
   *  ---------------- Mixins ------------------
   */
  mixins: [TitleMixin],
};
</script>
